import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import BrandsPage from "./pages/BrandsPage";
import AboutPage from "./pages/AboutPage";
import WholesalePage from "./pages/WholesalePage";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Orders from "./pages/admin/Orders";
import Products from "./pages/admin/Products";
import Categories from "./pages/admin/Categories";
import Customers from "./pages/admin/Customers";
import Discounts from "./pages/admin/Discounts";
import Settings from "./pages/admin/Settings";
import Invoices from "./pages/admin/Invoices";
import Shipments from "./pages/admin/Shipments";
import Returns from "./pages/admin/Returns";
import AbandonedCarts from "./pages/admin/AbandonedCarts";
import AdminBrands from "./pages/admin/Brands";
import Attributes from "./pages/admin/Attributes";
import Stock from "./pages/admin/Stock";
import Suppliers from "./pages/admin/Suppliers";
import Reviews from "./pages/admin/Reviews";
import CustomerGroups from "./pages/admin/CustomerGroups";
import Tickets from "./pages/admin/Tickets";
import Campaigns from "./pages/admin/Campaigns";
import Banners from "./pages/admin/Banners";
import Seo from "./pages/admin/Seo";
import CmsPages from "./pages/admin/CmsPages";
import Reports from "./pages/admin/Reports";
import Modules from "./pages/admin/Modules";
import Users from "./pages/admin/Users";
import AccountLayout from "./pages/account/AccountLayout";
import AccOverview from "./pages/account/AccOverview";
import AccOrders from "./pages/account/AccOrders";
import AccInvoices from "./pages/account/AccInvoices";
import AccProfile from "./pages/account/AccProfile";
import AccAddresses from "./pages/account/AccAddresses";
import AccChat from "./pages/account/AccChat";
import AccB2B from "./pages/account/AccB2B";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname, search]);
  return null;
};

const ShopLayout = () => (
  <div className="min-h-screen flex flex-col bg-white text-[#111111]">
    <Header />
    <main className="flex-1 pb-16 lg:pb-0">
      <Outlet />
    </main>
    <Footer />
    <CartDrawer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <ScrollToTop />
        <Routes>
          <Route element={<ShopLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/kategorija/:slug" element={<CategoryPage />} />
            <Route path="/prece/:id" element={<ProductPage />} />
            <Route path="/mekle" element={<CategoryPage mode="search" />} />
            <Route path="/akcijas" element={<CategoryPage mode="sale" />} />
            <Route path="/jaunumi" element={<CategoryPage mode="new" />} />
            <Route path="/grozs" element={<CartPage />} />
            <Route path="/noformesana" element={<CheckoutPage />} />
            <Route path="/zimoli" element={<BrandsPage />} />
            <Route path="/par-mums" element={<AboutPage />} />
            <Route path="/vairumtirdznieciba" element={<WholesalePage />} />
            <Route path="/konts" element={<AccountLayout />}>
              <Route index element={<AccOverview />} />
              <Route path="pasutijumi" element={<AccOrders />} />
              <Route path="rekini" element={<AccInvoices />} />
              <Route path="rekviziti" element={<AccProfile />} />
              <Route path="adreses" element={<AccAddresses />} />
              <Route path="sazina" element={<AccChat />} />
              <Route path="b2b" element={<AccB2B />} />
            </Route>
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="pasutijumi" element={<Orders />} />
            <Route path="rekini" element={<Invoices />} />
            <Route path="sutijumi" element={<Shipments />} />
            <Route path="atgriesanas" element={<Returns />} />
            <Route path="pamestie-grozi" element={<AbandonedCarts />} />
            <Route path="produkti" element={<Products />} />
            <Route path="kategorijas" element={<Categories />} />
            <Route path="zimoli" element={<AdminBrands />} />
            <Route path="atributi" element={<Attributes />} />
            <Route path="krajumi" element={<Stock />} />
            <Route path="piegadataji" element={<Suppliers />} />
            <Route path="atsauksmes" element={<Reviews />} />
            <Route path="klienti" element={<Customers />} />
            <Route path="klientu-grupas" element={<CustomerGroups />} />
            <Route path="atbalsts" element={<Tickets />} />
            <Route path="atlaides" element={<Discounts />} />
            <Route path="kampanas" element={<Campaigns />} />
            <Route path="baneri" element={<Banners />} />
            <Route path="seo" element={<Seo />} />
            <Route path="cms" element={<CmsPages />} />
            <Route path="atskaites" element={<Reports />} />
            <Route path="moduli" element={<Modules />} />
            <Route path="iestatijumi" element={<Settings />} />
            <Route path="lietotaji" element={<Users />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
